import { UserFeatureFlags } from 'enums/user-membership-features';
import FeatureFlag from 'modules/FeatureFlag';
import ProfileAlphaToggle from 'components/ProfileAlphaToggle';

export default function withProfilesAlphaFlag(NewComponent, FallbackComponent) {
  const showSwitchButton = !!localStorage.getItem('profiles-alpha');

  return (props) => (
    <FeatureFlag flag={UserFeatureFlags.profilesAlpha}>
      {(enabled) => (
        <ProfileAlphaToggle enabled={enabled & showSwitchButton}>
          {(enabled) => (enabled ? <NewComponent {...props} /> : <FallbackComponent {...props} />)}
        </ProfileAlphaToggle>
      )}
    </FeatureFlag>
  );
}
